/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_CustomersInputs */

const vi_report_debt_customers = /** @type {(inputs: Report_Debt_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng nợ`)
};

/**

* @param {Report_Debt_CustomersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_customers = /** @type {((inputs?: Report_Debt_CustomersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_CustomersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_customers(inputs)
});